import { useMemo } from 'react';
import { useGraphneGraphTask } from '../../../../queryHooks/productionPlanHooks';

export const useTaskDependencies = (taskId: string | number) => {
  const { data: taskGraph, isLoading } = useGraphneGraphTask(taskId);

  const { previousTasks, nextTasks } = useMemo(() => {
    if (!taskGraph?.nodes || !taskGraph?.edges || !taskGraph.entryNode) {
      return { previousTasks: [], nextTasks: [] };
    }

    const currentNodeId = taskGraph.entryNode.nodeId;

    const incomingEdges = taskGraph.edges.filter(
      (edge) => edge.edgeType === 'TaskToTaskEdge' && edge.toNode === currentNodeId,
    );

    const outgoingEdges = taskGraph.edges.filter(
      (edge) => edge.edgeType === 'TaskToTaskEdge' && edge.fromNode === currentNodeId,
    );

    const previous = incomingEdges
      .map((edge) => {
        const node = taskGraph.nodes?.find((n) => n.nodeType === 'TaskNode' && n.nodeId === edge.fromNode);
        return node?.nodeType === 'TaskNode' ? node : null;
      })
      .filter((node): node is Extract<typeof node, { nodeType: 'TaskNode' }> => node !== null);

    const next = outgoingEdges
      .map((edge) => {
        const node = taskGraph.nodes?.find((n) => n.nodeType === 'TaskNode' && n.nodeId === edge.toNode);
        return node?.nodeType === 'TaskNode' ? node : null;
      })
      .filter((node): node is Extract<typeof node, { nodeType: 'TaskNode' }> => node !== null);

    return { previousTasks: previous, nextTasks: next };
  }, [taskGraph]);

  return { previousTasks, nextTasks, isLoading };
};
